(function () {
  const KEY_PREFIX = 'cdh_scroll_';

  function getPageKey() {
    return KEY_PREFIX + window.location.pathname + window.location.search;
  }

  function saveScroll() {
    sessionStorage.setItem(getPageKey(), String(window.scrollY));
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');

    if (
      href &&
      (href.includes('/products/') || link.closest('.card-wrapper, .product-card, .grid__item'))
    ) {
      saveScroll();
    }
  });

  window.addEventListener('beforeunload', saveScroll);

  window.addEventListener('pageshow', function () {
    const savedY = sessionStorage.getItem(getPageKey());

    if (savedY !== null) {
      setTimeout(function () {
        window.scrollTo({
          top: parseInt(savedY, 10),
          behavior: 'instant'
        });
      }, 80);
    }
  });
})();